import React from 'react';
import PropTypes from 'prop-types';
import { styled } from 'twin.macro';

import { pseudoStyles } from '@sopranodesign/pulse-components';

import styles from './styles';
import DisabledActionButton from '../DisabledActionButton';

const StyledButton = styled.button`
  ${styles}
  ${pseudoStyles}
`;

const Location = ({ response, handleButtonClick, hasHadReply, ...props }) => {
  const doesSendMessage = response.action ? true : false;

  if (hasHadReply && doesSendMessage && response.expires !== '') {
    return <DisabledActionButton response={response} {...props} />;
  }

  const handleClick = () => {
    if (response.action && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (!position || !position.coords) {
            return;
          }

          const { latitude, longitude } = position.coords;
          handleButtonClick(response.action, latitude, longitude);
        }
      );
    }

    return true;
  };

  return (
    <StyledButton {...props} colour="white" onClick={handleClick} type="button">
      {response.label}
    </StyledButton>
  );
};

Location.propTypes = {
  response: PropTypes.shape({
    label: PropTypes.string.isRequired,
    action: PropTypes.string,
    expires: PropTypes.bool
  }).isRequired,
  handleButtonClick: PropTypes.func,
  hasHadReply: PropTypes.bool
};

export default Location;
